import "../sass/main.scss";

import "./utilities/scrollbar.js";
import "./utilities/header-height.js";
import "./utilities/keyboard-only-focus.js";

import "./modules/accordion.js";
import "./modules/alert.js";
import "./modules/back-to-top.js";
import "./modules/branchnav.js";
import "./modules/cookie-notice.js";
import "./modules/dropdown-handler.js";
import "./modules/fellowship-dropdown-handler.js";
import "./modules/ga_events.js";
import "./modules/header-search.js";
import "./modules/header.js";
import "./modules/match-day-countdown.js";
import "./modules/menu.js";
import "./modules/print.js";
import "./modules/share.js";
import "./modules/tabs.js";

import "./modules/iop-carousel.js";


console.log("main.js");